import { render, staticRenderFns } from "./Sv2Node.vue?vue&type=template&id=071cb8c2&scoped=true&"
import script from "./Sv2Node.vue?vue&type=script&lang=js&"
export * from "./Sv2Node.vue?vue&type=script&lang=js&"
import style0 from "./Sv2Node.vue?vue&type=style&index=0&id=071cb8c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071cb8c2",
  null
  
)

export default component.exports